import gql from 'graphql-tag';
export default gql`
  mutation getQuotePDF {
    getQuotePDF {
      url
    }
  }
`;
